import type { FormattedProductBundle } from 'reducers/detail/productDetail';
import type { PerformanceAttribute } from 'types/cloudCatalog';
import { uniqBy } from 'helpers/lodashReplacement';
import { getStyleByColor, isKidsShoe, isPerformanceAttribute } from 'helpers/ProductUtils';
import { PERFORMANCE_CATEGORIES, TECH_SPECS_ACCORDION_HEADING } from 'constants/product';
import { Accordion } from 'components/common/Accordion';
import { TechSpecsDisplay } from 'components/productdetail/accordions/TechSpecsDisplay';

export interface HighlightsAccordionProps {
  colorId: string;
  productDetail?: FormattedProductBundle;
}

export const TechSpecsAccordion = ({ colorId, productDetail }: HighlightsAccordionProps) => {
  if (!productDetail || !PERFORMANCE_CATEGORIES.includes(productDetail.defaultCategory)) {
    return null;
  }

  const { styles } = productDetail;
  const { taxonomyAttributes } = getStyleByColor(styles, colorId);
  const performanceAttributes = uniqBy<PerformanceAttribute>(taxonomyAttributes.filter(isPerformanceAttribute), a => a?.attributeId);

  if (!performanceAttributes.length || isKidsShoe(taxonomyAttributes)) {
    return null;
  }

  return (
    <div data-test-id="highlightsAccordion">
      <Accordion heading={TECH_SPECS_ACCORDION_HEADING}>
        <div className="grid grid-cols-2 gap-5 px-4">
          {performanceAttributes.map(attribute => (
            <TechSpecsDisplay attribute={attribute} />
          ))}
        </div>
      </Accordion>
    </div>
  );
};
